import React, {Component} from 'react';
import Relay from 'react-relay';
// import initRelayNetworking from '../../helper/network.js'
import NavbarLogin from '../../components/navbarLogin'
// import AddConversationMutation from '../../mutations/AddConversationMutation';

export default class Login extends Component{

  constructor(props)
  {
    super(props);

    this.state={em:false,pwd:false,success:false,error:false};
    this.validateEmail=this.validateEmail.bind(this);
    this.pwdCheck=this.pwdCheck.bind(this);
    this.sendData=this.sendData.bind(this);
  }

  validateEmail() {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.setState({em:re.test(this.refs.email.value.trim())});
  }

  pwdCheck()
  {
    var pd=this.refs.pwrd.value.trim();

    if(pd=="")
      this.setState({pwd:false});
    else {
      this.setState({pwd:true});
    }
  }

  sendData()
  {
    var params = JSON.stringify({
      "email": this.refs.email.value
    });
    var url = 'http://surveymate-io.herokuapp.com/api/users/reset';
    var responseCode;
    var responseText;
    console.log(params);
    var self = this;
    var response = fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: params
    }).then(function (response) {
        // console.log(response.status);
        responseCode = response.status;
        responseText = response.statusText;
        return response.text();
    }).then(function (result) {
        // var jsonData = JSON.parse(result);
        // console.log(jsonData);
        // console.log(responseCode);
        if (responseCode == 204) {
          self.setState({success:true});
          self.setState({error:false});
        }
        else {
          self.setState({error:true});
          self.setState({success:false});
        }
    }).catch(function (error) {
      console.error('An error occured');
      console.error(error);
    });
  }

  render ()
  {

    var  eclass,btn1class,btn2class;
    var st={
        pro:{
        width:"100%",
        backgroundColor:"#1a84eb",
      },
      pro_h:{
        height:"9px",
        borderRadius: "2px",
      },

      in:{
        height: "50px",
        borderRadius: "5px",
      },
      small_:{
        opacity: 0.5,
         fontSize: "12px",
         letterSpacing: "0.3px",
         color: "#000000",
      },
      bttn_attri:{
        height:"44px",
        backgroundColor:"#1a84eb",
        border:"none"

      },

      prev_attri:{
        textDecoration:"none",
        color:"#000000",
        border:"none"
      },
      or_:{
        paddingTop:"10px",
      }
    }

    if(this.state.em)
    {
      eclass="form-group has-success"
    }
    else {
      eclass="form-group has-error"
    }
    if(this.state.em)
    {
      btn1class="btn btn-info btn-lg pull-left col-md-5";
      btn2class="btn btn-info  btn-lg pull-right col-md-5";
      st.bttn_attri.backgroundColor="#1a84eb";
    }
    else {
      btn1class="btn btn-info btn-lg pull-left col-md-5 disabled";
      btn2class="btn btn-info  btn-lg pull-right col-md-5 disabled";
      st.bttn_attri.backgroundColor="#d1d1d1";
    }
    var error="";
    if(this.state.error)
    {
      error=<div className="text-danger">No such e-mail address found</div>
    }
    var success="";
    if(this.state.success)
    {
      success=<div className="text-success">E-mail successfully sent</div>;
    }
      return (
        <div>
        <div>
          <NavbarLogin />
        </div>
        <div>
          <h1 className="text-center">Reset Your Password</h1>
        </div>

        <div className="row">
        <div className="col-md-2"></div>
        <div className="col-md-8">
          <form role="form">
            <div className={eclass} >
              <label htmlFor="usr">EMAIL</label>
              <input type="text" className="form-control" id="usr" style={st.in} placeholder="Enter E-mail address" ref="email" onChange={this.validateEmail}/>
            </div>
            {success}
            {error}
          </form>
        </div>
        
        <div className="col-md-2"></div>
        </div>
        <br />
        <br />
        <br />

        <div className="row">
          <div className="col-md-2"></div>
          <div className="col-md-8">
              <div className="col-md-7">
                <div className="row">
                  <a className={btn2class} style={st.bttn_attri} onClick={this.sendData}><small>Reset Password</small>
                    <small><span className="glyphicon glyphicon-menu-right glyphicon"></span></small>
                  </a>
                  </div>
              </div>
            </div>
          <div className= "col-md-2"></div>
        </div>


        </div>
      );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/forgot/index.js
 **/